import React, { ReactChild } from 'react';
import styled from 'styled-components';

type Props = {
  children: ReactChild | ReactChild[];
};

const StyledExtra = styled.span`
  color: #04BD3B;
  font: normal normal normal 12px/14px Helvetica;
  display: inline-block;
`;

const Extra = ({ children }: Props) => {
  return <StyledExtra>{children}</StyledExtra>;
};

export default Extra;
